import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { viewerURLtoPreviewer } from 'libs/rendering/utils';
import { imageSrc } from 'apps/file/utils';
import { conf as mainConf } from 'apps/config.yaml';

import { Link } from 'core/routing';
import { Date } from 'apps/components/date';
import { Button, Heading } from 'components';
import { CardIndicator } from 'legacyComponents/cards/types/indicator';
import { modalStore } from 'apps/modals/app';
import { ConfirmAction } from 'apps/modals/confirmAction/index';

import {
  MainShareCardWrapper,
  ImageWrapper,
  MainRowWrapper,
  ColumnBlock,
  UserColumnBlock,
  DateBlockWrapper,
  ActionsWrapper,
} from 'apps/share/blocks/shareCard.styles';

import { SharedBy } from '../../shared';

const ShareCard = props => {
  const { cardObject, cardNo, cardColumns, cardApp } = props;
  const [isVisible, setVisible] = useState(false);

  const handleMouseOver = () => setVisible(true);
  const handleMouseLeave = () => setVisible(false);
  const handleDeleteBtn = event => {
    event.preventDefault();
    event.stopPropagation();
    modalStore.SetModalComponent(ConfirmAction, {
      callBack: () => {
        cardApp.manager.manager.DeleteSharedFile(cardObject);
      },
      title: 'Are you sure you want to delete this Shared File?',
      undo: false,
    });
  };

  const noMargin = (cardNo + 1) % cardColumns === 0;
  if (cardObject === null) {
    return <CardIndicator noMargin={noMargin} type='sharedFile' />;
  }

  const hasPreview =
    cardObject?.revision?.file?.conversionGltfjson?.status === 'SUCCESS';

  const image = {
    completed: false,
    src: hasPreview
      ? viewerURLtoPreviewer(cardObject?.revision?.file?.viewerPath, {
          thumbnail: true,
        })
      : undefined,
  };

  return (
    <MainShareCardWrapper
      onMouseLeave={handleMouseLeave}
      onMouseOver={handleMouseOver}
    >
      <ImageWrapper>
        <img
          src={imageSrc(
            image,
            cardObject?.imageFallbackPath,
            mainConf?.imgSizes?.project?.card,
          )}
          alt='CAD model thumbnail'
        />
      </ImageWrapper>
      <MainRowWrapper>
        <UserColumnBlock>
          <Link {...cardObject?.route}>
            <Heading
              variant={isVisible ? 'secondary' : 'primary'}
              margin='0 0 small 0'
              singleLine
              level='3'
            >
              {cardObject?.name}
            </Heading>
          </Link>
          <SharedBy space={cardObject?.space} />
        </UserColumnBlock>
        <MainRowWrapper around>
          <ColumnBlock removePadding>
            <Heading singleLine level='5' weight='regular'>
              Revision {cardObject?.revisionCount}
            </Heading>
          </ColumnBlock>
          <DateBlockWrapper>
            <Date value={cardObject?.revision?.lastUpdated} />
          </DateBlockWrapper>
        </MainRowWrapper>
        <ActionsWrapper isVisible={isVisible}>
          <Button
            ariaLabel='Delete this Shared File'
            onClick={handleDeleteBtn}
            variant='destructive'
            size='small'
            outline
            icon='delete'
          />
          <Link {...cardObject?.route}>
            <Button
              size='small'
              outline
              variant='primary'
              text='Open'
              icon='arrow_right'
              iconPosition='right'
            />
          </Link>
        </ActionsWrapper>
      </MainRowWrapper>
    </MainShareCardWrapper>
  );
};

ShareCard.defaultProps = {
  imageSrc:
    'https://res.cloudinary.com/dbshcjrt3/image/upload/w_100,h_100,c_fill,g_auto,q_auto/wikifactory-prod-uploads/149/wf_newlogo3_1.png',
};

ShareCard.propTypes = {
  imageSrc: PropTypes.string,
  cardObject: PropTypes.object,
  cardColumns: PropTypes.number,
  cardApp: PropTypes.object,
  cardNo: PropTypes.number,
};

export default observer(ShareCard);
